
import React, { useEffect, useState, useRef, createRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { Row, Col } from "react-bootstrap";
// import PopupApcode from './../../../PopUp/PopUpApcode'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
// import PopUpOther from "./../../../PopUp/PopUpOther";
import FullScreenDialog from "./../../PopUp/FullScreendialogs"
import { genURL, gengetURLTEST } from "../../_getjson.js";
import axios from 'axios'
import Moment from 'moment';
import Chackdocno from './../../CustomFunction/Docno/GetDocno'
import Grid from '@mui/material/Grid';
import Payforservice from './components/payforservice';
import Withholding from './components/withholding';
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Main(props) {
    const { parm } = props
    const Docgroupcode = useRef(null);
    const Docgroup = useRef(null);
    const [Rungroup, setRungroup] = useState("")
    const Totaltax0 = useRef();
    const [Docgrouptxt, setDocgrouptxt] = useState("")
    const [value, setValue] = React.useState(0);

    const [openFullScreenDialog, setopenFullScreenDialog] = useState(false);
    const [titleFullScreenDialog, settitleFullScreenDialog] = useState("");
    const [typeFullScreenDialog, settypeFullScreenDialog] = useState("");
    const [dataMultipletax, setdataMultipletax] = useState("");
    const [listitem1, setlistitem1] = useState([]);
    const [Payforservicedata, setPayforservicedata] = useState(parm[1]);
    const [Withholdingdata, setWithholdingdata] = useState(parm[2]);
    const [tableWithholding, settableWithholding] = useState([]);

    const [Docgroupcodes, setDocgroupcodes] = useState("");

    useEffect(() => {
        console.log("parm ", parm[1]);
        console.log("parm ", parm[2]);
        // หน้าหลัก
        Get_CSDOCGROUP(parm[0].Docgroupcode0)
        Totaltax0.current.value = parseFloat(parm[0].Wtaxamount).toFixed(2)
    }, []);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const Switch_OtherPopup = (type) => {
        let pram = {
            type: type,
            from: "CSAPWTAX_RUN",
        }
        setdataMultipletax(pram)
        setopenFullScreenDialog(true)
        settitleFullScreenDialog("ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP")
        settypeFullScreenDialog(type)
    };
    const CloseDialog = (e) => {
        setopenFullScreenDialog(e)
    }
    const ReturnData = (e) => {
        console.log(e);
        if (e) {
            let data = e[1].split('|')
            if (typeFullScreenDialog === 'Groupdataall') {
                Docgroupcode.current.value = data[0]
                Docgroup.current.value = data[1]
                setDocgrouptxt(data[1]);
            }
        }
    }
    const onClick = (e) => {
        if (e.target.name === "Docgroup") {
            Docgroup.current.value = Docgroupcode.current.value
            Docgroup.current.select()
        }
    }
    const onBlur = (e) => {
        if (e.target.name === "Docgroup") {
            Docgroup.current.value = Docgrouptxt
        }
    }
    const sendData = (e) => {
        let resdata = []
        resdata.push(e)
        props.resdata(resdata)
    }
    const onBlurAction = (e) => {
        switch (e.target.name) {
            case "Totaltax0": Totaltax0.current.value = parseFloat(e.target.value).toFixed(2); break;
            default:
                break;
        }
    }
    const Get_CSDOCGROUP = async (code) => {
        await console.log("Get_CSDOCGROUP Docgroupcodes", parm[0].Docgroupcode0);

        // มาต่อต่อไปคือเอาตัวนี้ไปตัดแล้วบวกเลขเข้าไป
        await Chackdocno(parm[0].Docgroupcode0, "CSAPWTAX_RUN").then(async (result1) => {
            if (result1 !== undefined) {
                Docgroupcode.current.value = result1;
                setDocgroupcodes(result1)
            } else {
                setDocgroupcodes("")
            }
        }).catch((err) => {
            console.log(err);
        });

        await console.log("Get_CSDOCGROUP Docgroupcodes", Docgroupcodes);
        var url = "CSDOCGROUP/Searchbycode?code=" + code + "&tablename=CSAPWTAX_RUN"
        console.log("Get_CSDOCGROUP", genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then(async (res) => {
            if (res.data.length > 0) {
                // Docgroupcode.current.value = res.data[0].CODE
                Docgroup.current.value = res.data[0].MYNAMETH
                setDocgrouptxt(res.data[0].MYNAMETH)
                setRungroup(res.data[0].RUNGROUP);

            } else {
                Docgroupcode.current.value = ("")
                Docgroup.current.value = ("")
                setDocgrouptxt("")
                setRungroup("");
            }
        })
    }



    const sumdata = async (name, data) => {
        console.log("sumdata", name, data);
        if (name === "payfirservice" && data.sum) {
            Totaltax0.current.value = await data.sum
        }
        if (name === "Withholding" && data.sumTax) {
            Totaltax0.current.value = await data.sumTax
        }
        let resdata = []
        resdata.push(true)
        let data0 = ""
        data0 = {
            Docgroupcode0: Docgroupcode.current.value,
            Totaltax0: Totaltax0.current.value,
        }
        resdata.push(data0)

        var data1 = ""
        var data2 = ""
        var table = []
        if (name === "payfirservice") {
            let Totaltax1 = data.Totaltax1 ? data.Totaltax1 : Payforservicedata.Totaltax1
            let Vat = data.Vat ? data.Vat : Payforservicedata.Vat
            data1 = await {
                PaymentDocno: parm[1].PaymentDocno,
                Refdocno: parm[1].Refdocno,
                Totaltax1: Totaltax1,
                Vat: Vat,
                payfirservice: data.listitem
            }
            setPayforservicedata(data1)
            if (data.sum) {   /// มาต่อ
                var j = 0
                let Docgroupcode = Docgroupcodes.split('-')
                let conttxtpattern = Docgroupcode[2].length
                let txtpattern = ""
                let tvcode = ""
                for (let i = 0; i < data.listitem.length && data.listitem[i].Productcode; i++) {
                    txtpattern = ""
                    if (i === 0) {
                        tvcode = Docgroupcodes
                    } else if (i > 0, i < 9) {
                        for (let index = 0; index < conttxtpattern - 1; index++) {
                            txtpattern += "0"
                        }
                        tvcode = Docgroupcode[0] + "-" + Docgroupcode[1] + "-" + txtpattern + (i + 1)
                    } else if (i > 9, i < 99) {
                        for (let index = 0; index < conttxtpattern - 2; index++) {
                            txtpattern += "0"
                        }
                        tvcode = Docgroupcode[0] + "-" + Docgroupcode[1] + "-" + txtpattern + (i + 1)
                    }
                    else if (i > 99, i < 999) {
                        for (let index = 0; index < conttxtpattern - 3; index++) {
                            txtpattern += "0"
                        }
                        tvcode = Docgroupcode[0] + "-" + Docgroupcode[1] + "-" + txtpattern + (i + 1)
                    }
                    var result = ""
                    var url1 = "CSINCOMETYPE/Search?Code=" + data.listitem[i].Incometype
                    console.log(genURL(url1));
                    let Income = ""
                    let Incomecode = ""
                    await axios.get(genURL(url1), { timeout: 60000 }).then(async (res) => {
                        if (res.data.length > 0) {
                            Income = await res.data[0].MYNAMETH
                            Incomecode = await res.data[0].CODE
                        }
                    })
                    table[i] = await {
                        numrow: i + 1,
                        Taxinvoice: tvcode,
                        Income: Income,
                        Incomecode: Incomecode,
                        Invoicedate: Moment(new Date()).format('YYYY-MM-DD'),
                        PayableCode: parm[2].APCode,
                        PayableName: parm[2].APName,
                        Remark: data.listitem[i].Productname,
                        Taxrate: data.listitem[i].Wtaxrate,
                        Amountbeforetax: data.listitem[i].Amount,
                        Tax: data.listitem[i].Taxamount,
                        Actingonbehalf: parm[2].APCode,
                        Condition: '1',
                    }
                    j = i
                }
                if (j > 0) {
                    settableWithholding(table)
                    data2 = await {
                        APCode: parm[2].APCode,
                        APName: parm[2].APName,
                        // ข้อมูลในตาราง
                        withholding: (table),
                    }
                    setWithholdingdata(data2)
                }
            }
        }
        resdata.push(data1)
        if (name === "Withholding") {
            data2 = await {
                APCode: parm[2].APCode,
                APName: parm[2].APName,
                // ข้อมูลในตาราง
                withholding: (tableWithholding.length > 0 ? tableWithholding : data.listitem),
            }
            setWithholdingdata(data2)
        }
        resdata.push(data2)
        props.resdata(resdata)
    }
    return (
        <div className="panel-body DivTable">

            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} type={typeFullScreenDialog} parm={dataMultipletax}
                closeDialog={e => CloseDialog(e)}
                resData={e => ReturnData(e)}
            // type เป็นชื่อ Components subDialog ใช้เป็นเงือนไขในการเปิด subDialog
            />
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="ชำระค่าบริการ" {...a11yProps(0)} />
                        <Tab label="ภาษีหัก ณ ที่จ่าย" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Payforservice parm={Payforservicedata} sumdata={(e, e1) => sumdata(e, e1)} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Withholding parm={Withholdingdata} sumdata={(e, e1) => sumdata(e, e1)} />
                </TabPanel >
                {/* <div style={{ margin: '25px' }}> */}
                <Grid>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">กลุ่มภาษีหัก ณ ที่จ่าย  </span>
                                    <input type="text" className="form-control hidden" ref={Docgroupcode} id="Docgroupcode" name="Docgroupcode" />
                                    <input type="text" className="form-control" ref={Docgroup} id="Docgroup" name="Docgroup" onClick={onClick} onBlur={onBlur} />
                                    <span id="Groupdataall" className="input-group-addon icon" onClick={() => Switch_OtherPopup("Groupdataall")}>
                                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                    </span>
                                </div>
                            </div>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={4} sm={12} md={4} lg={4}>
                            </Col>
                            <Col xs={4} sm={12} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <Button variant="outlined" size="small" onClick={e => sendData(false)}> ตกลง </Button>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={4} sm={12} md={4} lg={4}>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รวมยอดภาษี  </span>
                                            <input type="text" className="form-control" ref={Totaltax0} name="Totaltax0" onBlur={e => onBlurAction(e)} />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
                {/* </div> */}
            </Box>
        </div>
    )
}
Main.prototype = {
    parm: PropTypes.array
}
